<i18n src="../../../../lang/components/ad/favorite-button/favorite-button.json"></i18n>

<script>
	var Ladda = require('ladda');
	
	export default {
		props: ['fk_property', 'fk_roommate', 'is_favorite'],

		data: function () {
			return {
				api_url: '',
				id: null,
				icon : 'far',
				mensagem : this.$t('mark_as_favorite'),
			};
		},

		methods: {
			setFavorite: function() {
				if (this.fk_property) {
					this.api_url = '/property/set-favorite';
					this.id = this.fk_property;
				}

				if (this.fk_roommate) {
					this.api_url = '/roommate/set-favorite';
					this.id = this.fk_roommate;
				}

				let ladda_el = this.$el.querySelector('.ladda-button');

				if (!_.isEmpty(ladda_el)) {
					let l = Ladda.create( ladda_el );
					l.start();
				}

				axios.post(this.api_url, { id: this.id }).then((data) => {
					if (typeof l !== typeof undefined)
						l.stop();

					if (data.data.response) {
						let str = '';

						if (this.fk_property) {
							str = this.$t('ad');
						}

						if (this.fk_roommate) {
							str = this.$t('roomate');
						}

						if (data.data.msg === 'del'){
							this.icon = 'far';
							this.mensagem = this.$t('mark_as_favorite');
						} else {
							this.icon = 'fas';
							this.mensagem = this.$t('remove_from_favorite');
						}
					} else {
						$.App.error(this.$t('error_message'));
					}
				}).catch((error) => {
					if (typeof l !== typeof undefined)
						l.stop();
					if (typeof error.response !== typeof undefined && error.response.status == 401) {
						EventBus.$emit('open-modal', 'register-modal', { fk_property: this.fk_property, fk_roommate: this.fk_roommate });
						gtag('event', 'show_login_modal', {
							'event_category': 'favorite_button',
							'event_label': 'add_favorite',
						});
					} else {
						$.App.error(this.$t('error_message'));
						Sentry.captureException(error);
					}
				});
			},
			checkFavorite() {
				if(this.is_favorite){
					this.icon = 'fas';
					this.mensagem = this.$t('remove_from_favorite');
				}else {
					this.icon = 'far';
					this.mensagem = this.$t('mark_as_favorite');
				}
			},
		},
		created() {
			this.checkFavorite();
		},
	}
</script>
